import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year5/Spring/Statistics/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'Statistics',
  weeks: [11, 12],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/Statistics/1DrawLineGraphs" */ './1DrawLineGraphs'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/Statistics/2ReadAndInterpretLineGraphs" */ './2ReadAndInterpretLineGraphs'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/Statistics/3ReadAndInterpretTables" */ './3ReadAndInterpretTables'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(/* webpackChunkName: "Year5/Spring/Statistics/4TwoWayTables" */ './4TwoWayTables')
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/Statistics/5ReadAndInterpretTimetables" */ './5ReadAndInterpretTimetables'
        )
    })
  ]
});
export default Block;
